import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@mui/styles";
import RouteConstants from "../../common/RouteConstants";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  CircularProgress,
  Backdrop,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Divider,
} from "@mui/material";
import UserViewList from "./UserViewList";
import data from "../../mockData/usersList.json";
import { AppDataContext } from "../../common/appContext";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { BallotDashboardService } from "../../services/ballotDashboard.Service";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  listItems: {
    display: "flex",
    flexWrap: "wrap",
    paddingTop: theme.spacing(2),
    justifyContent: "space-around",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  userList: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
}));
export default function ManageUsersContainer(props) {
  const classes = useStyles();
  let navigate = useNavigate();
  const { user, applicationUsers, setUserPersonate } =
    useContext(AppDataContext);
  let [allUser, setAllUsers] = useState([]);
  let [isLoading, setIsLoading] = useState(true);
  let [searchText, setSearchText] = useState("");
  let [teamBallotDashboardFlag, setTeamBallotDashboardFlag] = useState(false);

  useEffect(() => {
    setAllUsers(applicationUsers);
  }, [applicationUsers]);
  useEffect(() => {
    filterUserOnSearch(searchText);
  }, [searchText]);

  useEffect(() => {
    BallotDashboardService.getTeamBallotDashboardFlagForTeamUser().then(
      (response) => {
        setTeamBallotDashboardFlag(
          response[0].childName === "true" ? true : false
        );
      }
    );
  }, []);

  useEffect(() => {
    setIsLoading(false);
  }, [user]);

  const setPersonate = async (user) => {
    await setUserPersonate(user);
    if (teamBallotDashboardFlag) {
      navigate(RouteConstants.TEAM_BALLOT_DASHBOARD);
    }
    // else if (user.appRoles.includes("DraftGreenRoomBallotUser")) {
    //   navigate(RouteConstants.TEAM_GREEN_BALLOT_VOTE);
    // }
    else {
      navigate(RouteConstants.HOME);
    }
  };

  const onSearchClick = () => {
    filterUserOnSearch(searchText);
  };
  const filterUserOnSearch = (text) => {
    if (text !== "") {
      let filteredUser = applicationUsers.filter((x) => {
        if (
          x.firstName.toLowerCase().includes(text.toLowerCase()) ||
          x.lastName.toLowerCase().includes(text.toLowerCase())
        ) {
          return x;
        }
      });
      setAllUsers(filteredUser);
    } else {
      setAllUsers(applicationUsers);
    }
  };
  const handleClearSearch = () => {
    setAllUsers(applicationUsers);
    setSearchText("");
  };

  return (
    <Grid className={classes.root}>
      <Box component="div">
        <FormControl
          sx={{ m: 1, width: "40ch", margin: (theme) => theme.spacing(2) }}
          variant="outlined"
          size="small"
        >
          <InputLabel htmlFor="outlined-adornment-password">
            Search User
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                {searchText !== "" && (
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClearSearch}
                    edge="end"
                  >
                    <ClearIcon color="secondary" />
                  </IconButton>
                )}
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={onSearchClick}
                  edge="end"
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
            label="Search User"
          />
        </FormControl>
      </Box>
      <Divider />
      <Grid container className={classes.userList}>
        {allUser &&
          allUser.map((user) => {
            return (
              <React.Fragment key={user.userId}>
                <UserViewList
                  userData={user}
                  setUserPersonate={setPersonate}
                  setIsLoading={setIsLoading}
                />
              </React.Fragment>
            );
          })}
      </Grid>
      <Backdrop className={classes.backdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Grid>
  );
}
